module.exports = __webpack_public_path__ + "img/Jump Casting71.6ce9fc63.jpg";